import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import PeopleNav from "../layout/people-nav";
import { useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLongArrowAltRight } from "react-icons/fa";
import axios from 'axios';
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import GetPeople from "./GetPeople";
import Metatag from "../../hooks/Metatag";


export default function People() {
  const [toggler, setToggler] = useState(true);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();

  }, []);

  var settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const {pcategory_pagename} = useParams()
  const qs_pcategory_pagename = pcategory_pagename

  const [peopleCategory, setPeopleCategoryList] = useState(null);

    useEffect(() => {
        let _obj = new Object();
        _obj.pcategory_status = 1;
        // setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getcategoryHavingPeopleList", _obj)
                .then((response_list) => {
                  if(response_list.data === 'error')
                  {
                    navigate('/error-page')
                  }
                  else
                  {
                    // pass the result in the success function of the respective page
                    setPeopleCategoryList(response_list.data[0]);
                  }
                });
        // }, 300);

    }, [])

    //getting perticular people category list
  const [getPerticularpeopleCategory, setPerticularPeopleCategoryList] = useState([]);
  
  //saving people category id value to get subcategory list
  const [getPcategoryId,setpcategoryId] = useState();
    //People category list
    useEffect(()=>{
      let _obj = new Object();
      _obj.pcategory_status = 1;
      _obj.pcategory_pagename = qs_pcategory_pagename

        axios.post(global.variables.strApiUrl + "/peoplecategoryApi/getpeopleCategoryList",_obj)
        .then((response_perticular_pCategory) => {
          if(response_perticular_pCategory.data === 'error')
                  {
                    navigate('/error-page')
                  }
                  else
                  {
              if(response_perticular_pCategory.data[0].length > 0){

                // pass the result in the success function of the respective page
                setPerticularPeopleCategoryList(response_perticular_pCategory.data[0]);
                setpcategoryId(response_perticular_pCategory.data[0][0]?.pcategory_id);
              }
              else{
                window.location = global.variables.strDomainUrl  ;
              }
            }

        }); 
  },[qs_pcategory_pagename])

  
  const [peopleSubCategoryList, setPeopleSubCategoryList] = useState([]);
  
  const [blnHaspeople, setblnHaspeople] = useState(false);
  
  useEffect(()=>{
    let _obj = new Object()
    _obj.ps_pcategory_id = getPcategoryId
    _obj.ps_category_status = 1
    
      axios.post(global.variables.strApiUrl + "/peoplesubcategoryApi/getsubcategoryHavingActivePeopleList",_obj)
      .then((response_subCategory)=>{
        if(response_subCategory.data === 'error')
          {
            navigate('/error-page')
          }
          else
          {
            if(response_subCategory.data[0][0]?.ps_pcategory_id === getPcategoryId)
            {
              //set true when people count grater than zero 
                for (let i = 0; i < (Object.keys(response_subCategory.data[0]).length); i++) {
                  if (response_subCategory.data[0][i].ps_people_count > 0) {
                    
                      setblnHaspeople(true);
                  }
            }
              setPeopleSubCategoryList(response_subCategory.data[0])
            }
          }
          
      })
      
    
  },[getPcategoryId])

  

  return (
    <>
      <Header main_className="bg-header"></Header>

      {/* Metatag  */}
      <Metatag title='NDMC Team | NDMC Partners | NDMC Advisory Panel'  
                keywords='NDMC Team, IIT Bombay Faculty, NDMC Partners, NDMC Advisory Panel, NDMC Secretariat, NDMC Research Associates, NDMC Disease Modellers, Malaria Modellers, Tuberculosis Modellers, Vaccine Preventable Disease Modeller, Neglected Tropical Disease Modeller' 
                description='Partners, Advisory Panel and Disease Modellers of The National Disease Modelling Consortium India'
                />

      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('../images/bg-people.jpg')", backgroundSize: "cover", backgroundRepeat:"no-repeat", backgroundPosition:"center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5">
            <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">People</h1>
          </Container>
        </div>
      </Container>

      {
        peopleCategory != null ?
          peopleCategory.length > 0 ?

            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
              <PeopleNav qs_pcategory_pagename={qs_pcategory_pagename} peopleCategory={peopleCategory} ></PeopleNav>

                {
                  peopleSubCategoryList != null ?
                    blnHaspeople === true ?
                    peopleSubCategoryList.length > 0 ?
                    peopleSubCategoryList?.map((val_subcategory)=>{
                      return(
                      <GetPeople 
                          getPerticularpeopleCategory={getPerticularpeopleCategory}
                          subcategory_id={val_subcategory.ps_category_id}
                          val_subcategory={val_subcategory}
                          history={navigate}
                        />
                      )
                    })
                    : 
                    <Container className="text-center mt-2">
                      <span><b>No records found</b></span>  

                    </Container>
                    : 
                    <Row>
                      <span className="text-center">Loading...</span>
                    </Row>
                  
                  : 
                    <span>No records found</span>
                  
                }
                

            </Container>
          :
          <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
          <Row>
            <span className="text-center"><b>No records found</b></span>
          </Row>
        </Container>
        :
        <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
          <Row>
            <span className="text-center">Loading...</span>
          </Row>
        </Container>
      }

      {/* Breadcrumb */}
      <Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center">
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>People</Breadcrumb.Item>
          <Breadcrumb.Item active>
            {getPerticularpeopleCategory[0]?.pcategory_name}
            </Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}